const CUSTOMER_INFO_COOKIE_KEY = 'planner_customer_info';
const DEFAULT_EXPIRE_HOUR = 1;

type CustomerInfoCookieValue = {
  name: string;
  phone: string;
};

function isBrowser() {
  return typeof document !== 'undefined';
}

function getExpiresUtcString(hours = DEFAULT_EXPIRE_HOUR) {
  const date = new Date();
  date.setHours(date.getHours() + hours);
  return date.toUTCString();
}

function setCookie(name: string, value: string, hours: number = DEFAULT_EXPIRE_HOUR) {
  if (!isBrowser()) return;

  document.cookie = [
    `${name}=${encodeURIComponent(value)}`,
    'path=/',
    `expires=${getExpiresUtcString(hours)}`,
    'SameSite=Lax',
  ].join('; ');
}

function getCookie(name: string): string | null {
  if (!isBrowser()) return null;

  const cookies = document.cookie ? document.cookie.split('; ') : [];
  const prefix = `${name}=`;

  for (const cookie of cookies) {
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.substring(prefix.length));
    }
  }

  return null;
}

function removeCookie(name: string) {
  if (!isBrowser()) return;

  document.cookie = [
    `${name}=`,
    'path=/',
    'expires=Thu, 01 Jan 1970 00:00:00 GMT',
    'SameSite=Lax',
  ].join('; ');
}

function safeJsonParse<T>(value: string): T | null {
  try {
    return JSON.parse(value) as T;
  } catch (e) {
    return null;
  }
}

export function normalizePhoneNumber(phone: string) {
  return String(phone || '').replace(/\D/g, '').slice(0, 11);
}

export function saveCustomerInfoToCookie(payload: CustomerInfoCookieValue) {
  const normalizedPayload: CustomerInfoCookieValue = {
    name: String(payload?.name || '').trim(),
    phone: normalizePhoneNumber(payload?.phone || ''),
  };

  setCookie(CUSTOMER_INFO_COOKIE_KEY, JSON.stringify(normalizedPayload));
}

export function loadCustomerInfoFromCookie(): CustomerInfoCookieValue | null {
  const raw = getCookie(CUSTOMER_INFO_COOKIE_KEY);
  if (!raw) return null;

  const parsed = safeJsonParse<CustomerInfoCookieValue>(raw);
  if (!parsed) return null;

  return {
    name: String(parsed.name || '').trim(),
    phone: normalizePhoneNumber(parsed.phone || ''),
  };
}

export function clearCustomerInfoCookie() {
  removeCookie(CUSTOMER_INFO_COOKIE_KEY);
}